import { always, both, complement, equals, ifElse, isNil, path, isEmpty } from 'ramda';

export const renderWhen = (pred, fn) => ifElse(pred, fn, always(null));

export const renderWhenNotNil = fn => renderWhen(complement(isNil), fn);

export const renderWhenNotNilOrEmpty = fn => renderWhen(both(complement(isNil), complement(isEmpty)), fn);

export const renderWhenNotNilOrEmptyOtherwise = (fn, otherwise) =>
  ifElse(both(complement(isNil), complement(isEmpty)), fn, otherwise);

export const renderWhenNotNilOtherwise = (fn, otherwise) => ifElse(complement(isNil), fn, otherwise);

export const renderWhenTrue = fn => renderWhen(equals(true), fn);

export const renderWhenTrueOtherwise = (fn, otherwise) => ifElse(equals(true), fn, otherwise);

export const styleWhenTrue = (fn, styleTrue, styleFalse = null) => props =>
  ifElse(equals(true), always(styleTrue), always(styleFalse))(fn(props));

export const hasAnyPropChanged = (propsList, prevProps, nextProps) =>
  propsList.some(propName => {
    const propPath = propName.split('.');
    return path(propPath, nextProps) !== path(propPath, prevProps);
  });
